import { axios } from "helper/axios";
import { jarvisPrimeTransactionConstants } from "./jarvisPrimeTransactionConstants";

const jarvisPrimeTransactionApis = {};

jarvisPrimeTransactionApis.getTransactionList = ({ page, rowsPerPage })=>{
    return axios.get(jarvisPrimeTransactionConstants.PRIME_TRANSACTION_LIST_API, { 
        params: { 
            page, 
            limit: rowsPerPage,
            sort_direction: 'desc'
        } 
    });
}

export { jarvisPrimeTransactionApis };
